import { vModelRadio as _vModelRadio, mergeProps as _mergeProps, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1dc22196")

_pushScopeId("data-v-1dc22196")
const _hoisted_1 = { class: "radio__input" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "radio__control" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("label", {
    class: [{'inline': _ctx.inline}, "radio"]
  }, [
    _createVNode("span", _hoisted_1, [
      _withDirectives(_createVNode("input", _mergeProps({
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.internalValue = $event)),
        value: _ctx.value,
        type: "radio"
      }, _ctx.$attrs), null, 16, ["value"]), [
        [_vModelRadio, _ctx.internalValue]
      ]),
      _hoisted_2
    ]),
    _createVNode("span", {
      class: "radio__label",
      textContent: _toDisplayString(_ctx.label)
    }, null, 8, ["textContent"])
  ], 2))
})